<ng-container style="width:100%;height:100%">
  <app-header-nav-bar>
    <app-header-nav-snap-output [isAddClientDetails]="true" [snapNameNavHeader]="snapshotName"
        [ImageURL]="ImageURL" (defaultPanelChange)="onDefaultPanelChange($event)"></app-header-nav-snap-output>
    <app-header-section-list [clientSnapDetails]="clientDetails.clientDetails"></app-header-section-list>
    <app-header-home [moduleName]="'customsnapshot'" [additionalCheck]="additionalList" [exportReportInput]="exportReportInput"
    (OnSettingsSel)="OnSettingsSel($event)"></app-header-home>
</app-header-nav-bar>


  <!-- *ngIf="!isCreateCustomGroup" -->
  <div class="leftPanelandOutputArea" >
    <!-- <div class="leftpanel-view " style="background-color: lightgray;">
            <app-custom-leftpanel class="expandLeftPanel"></app-custom-leftpanel>
        </div> -->
    <!-- <app-leftpanel-snapshot class="expandLeftPanel" [onItemClick]="handleCheckboxClick" [moduleLists]="moduleList"
            (showOutput)="ShowOutput()" (snapNameNavHeader)="snapHeaderNameFun($event)"
            (BindImageURL)="brandLogo($event)" (valueChange)="toggleLeftPanel($event)"
            (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
            (isLoadSelection)="LoadSelection($event)" [selectedScenarioData]="selectedScenarioData"
            [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
            (additionalList)="additionalCheck($event)" [isCustomSnapshot]="true"
            (additionalFeatures)="additionalFeatures($event)" (customvariable)="customvariable($event)"
            (dataListChange) = "dataListChange($event)"></app-leftpanel-snapshot> -->

    <!-- <app-leftpanelnewdesign style="width:100%"  [handleCheckboxClick]="handleCheckboxClick" [moduleList]="moduleList"
        [selectedScenarioData]="selectedScenarioData" [isCustomSnapshot]="true"
            [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
            (showOutput)="ShowOutput()"   (snapNameNavHeader)="snapHeaderNameFun($event)"  (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
            (dataListChange) = "dataListChange($event)" (isLoadSelection)="LoadSelection($event)"
        >

        </app-leftpanelnewdesign> -->

        <!-- [style]="!showLeftPanel?'display:none':'display:flex'" -->

    <div class="leftpanel-parent" [hidden]="!showLeftPanel"  >
      <div #leftPanel class="leftpanelmaincontents" [ngClass]="showLeftPanel ? 'open' : 'closed'" [style]="isCreateCustomGroup?'width:100% !important':''">
        <div class="sections">
          <div class="section-components">
            <div class="subcomponent typography" (click)="sectionSelected('filter')"
              [ngClass]="isfilterSelected?'sectionSelected':'sectionNotSelected'">
              <div class="filter-icon" [ngClass]="isfilterSelected?'filter-icon-active':'filter-icon-notactive'"></div>
              <div class="component-name">Filters</div>
            </div>
            <div class="subcomponent typography" (click)="sectionSelected('savedSelection')"
              [ngClass]="isSavedSelectionSelected?'sectionSelected':'sectionNotSelected'">
              <div class="saved-selection-icon"
                [ngClass]="isSavedSelectionSelected?'saved-selection-icon-active':'saved-selection-icon-notactive'">
              </div>
              <div class="component-name">Saved Selections</div>
            </div>
            <div class="subcomponent typography" (click)="sectionSelected('features')"
              [ngClass]="isFeaturesSelected?'sectionSelected':'sectionNotSelected'">
              <div class="feature-icon" [ngClass]="isFeaturesSelected?'feature-icon-active':'feature-icon-notactive'">
              </div>
              <div class="component-name">Features</div>
            </div>
          </div>
          <div class="close-icon" (click)="toggleLeftPanel()"></div>
        </div>
        <!-- [hidden]="!isfilterSelected" -->
        <div class="filter-component"  [style]="!isfilterSelected?'height:0%;width:0%;opacity:0;visibility:hidden':'height:100%;width:100%'">
          <div  [style]="!isfilterSelected?'width:0%;opacity:0;visibility:hidden':'width:100%'" class="leftpanel">
            <app-leftpanel-snapshot class="expandLeftPanel" [style]="!isfilterSelected?'width:0rem;opacity:0;visibility:hidden;':'width:13rem;opacity:1'" [onItemClick]="handleCheckboxClick"
              [moduleLists]="moduleList" (showOutput)="ShowOutput()" (snapNameNavHeader)="snapHeaderNameFun($event)"
              (BindImageURL)="brandLogo($event)" (valueChange)="toggleLeftPanel($event)"
              (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
              (isLoadSelection)="LoadSelection($event)" [selectedScenarioData]="selectedScenarioData"
              [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
              (additionalList)="additionalCheck($event)" [isCustomSnapshot]="true"
              (additionalFeatures)="additionalFeatures($event)" (customvariable)="customvariable($event)"
              (dataListChange)="dataListChange($event)" (issubmitReset)="submitReset($event)"
              (snapshotselected)="snapshotselected" (sectionselected)="sectionselected" (subsectionselected)="subsectionselected"
              (increaseLeftpanelHeight)="increaseLeftpanelWidth($event)" [isAcrossdropDown]="isAcrossdropDown"
              ></app-leftpanel-snapshot>
          </div>
          <div *ngIf="isfilterSelected" class="submit-reset">
            <div class="btn btn-typography" [class.disabled]="!isSubmitReset" [ngClass]="isSubmitReset?'btn-active':'btn-notactive'"
              (click)="SubmitClicked()">Submit</div>
            <div class="btn btn-typography" [class.disabled]="!isSubmitReset" [ngClass]="isSubmitReset?'btn-active':'btn-notactive'"
              (click)="ResetClicked()">Reset</div>
          </div>
        </div>
        <div class="infoMessage" *ngIf="displayTable">
          <div class="infoBackButton config-btn CP" (click)="bindBackClickEvent()">
            Back
          </div>
          <div class="infoText" [innerHTML]="infoMessage"></div>
        </div>
        <!-- *ngIf="isSavedSelectionSelected && !displayTable" -->
        <div class="selection-component " [style]="!(isSavedSelectionSelected && !displayTable)?'width:0%;opacity:0;visibility:hidden;height:0%;padding:0rem':'width:100%;opacity:1'" >
          <div class="loadSelectionTable" [style]="!isSavedSelectionSelected?'width:0%;opacity:0.5;visibility:hidden;height:0%':'width:100%;opacity:1'">
            <div class="header-block list-container-options">
              <div class="header-arrow-block">
                <div class="list-container-text" (click)="toggleSaveSelectionList('userDefined')"> USER DEFINED
                  <div class="EntryIcon">
                    <div class="Icon EntryIconImage"></div>
                  </div>
                </div>

                <div class="search-block" title="Search"
                  *ngIf="isUserDefinedListVisible && loadUserDefinedSavedScenarioData.length>0">
                  <input type="text" [(ngModel)]="userDefinedSelectionQuery" class="search-input" placeholder="Search">
                  <div class="search-icon"></div>
                </div>
                <!-- <div class="arrow" (click)="toggleSaveSelectionList('userDefined')">
                            <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isUserDefinedListVisible}">
                            </div>
                          </div> -->
              </div>

            </div>
            <div class="list-container-options" *ngIf="isUserDefinedListVisible">
              <div class="custom-table-container">

                <!-- <table class="custom-table" *ngIf="displayTable"> -->
                <table class="custom-table">
                  <thead *ngIf="loadUserDefinedSavedScenarioData.length>0">
                    <tr>
                      <ng-container *ngFor="let col of columnConfig">
                        <ng-container *ngIf="isChangeOfEntryPointConfigured">
                          <th [style.width]="col.userDefined_width">
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                          <th [style.width]="col.userDefined_width_change">
                            {{ col.name }}
                          </th>
                        </ng-container>
                      </ng-container>

                    </tr>
                  </thead>
                  <tbody class="custom-load-table-body">
                    <tr [ngClass]="{'scenarioSelected': row.is_default}"
                      *ngFor="let row of loadUserDefinedSavedScenarioData| search: userDefinedSelectionQuery : ['selection_name']">
                      <td [style.width]="isChangeOfEntryPointConfigured? '50%':'80%'"
                        [title]="row.is_shared ? row.selection_name + '_Shared' : row.selection_name"
                        [ngClass]="{'ellipsis-cell': isChangeOfEntryPointConfigured,'ellipsis-cell-noentry': !isChangeOfEntryPointConfigured }">
                        <div class="scenarioName">
                          <!-- <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.is_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'userDefined')"> -->
                          {{ row.is_shared ? row.selection_name + '_Shared' : row.selection_name }}
                        </div>
                      </td>

                      <ng-container *ngIf="isChangeOfEntryPointConfigured">
                        <td [style.width]="'12%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.is_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'userDefined')">
                        </td>
                        <td [style.width]="'10%'" class="imageContainer CP LoadImageActive"
                         
                          (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP InfoImageActive"

                          (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP DeleteImageActive"

                          (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>

                        <!-- <td [style.width]="'14%'" class="imageContainer CP changeEntryPointImage"
                                    (click)="handleLoadOptionsClick('changeentrypoint', row,'userDefined')"></td> -->

                        <td [style.width]="'10%'" class="imageContainer CP ShareImageActive"
 
                          (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>

                      </ng-container>

                      <ng-container *ngIf="!isChangeOfEntryPointConfigured ">
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'ShareImageActive':'ShareImageInactive'"
                          (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>
                      </ng-container>



                    </tr>
                    <tr class="no-data" *ngIf="loadUserDefinedSavedScenarioData.length==0">
                      You have not created any saved selections.
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="header-block list-container-options">
              <div class="header-arrow-block">
                <div class="list-container-text" (click)="toggleSaveSelectionList('Shared With Me')"> SHARED WITH ME
                  <div class="EntryIcon">
                    <div class="Icon EntryIconImage"></div>
                  </div>
                </div>

                <div class="search-block" title="Search"
                  *ngIf="isSharedWithMeListVisible && loadSharedWithMeSavedScenarioData.length>0">
                  <input type="text" [(ngModel)]="sharedWithMeSelectionQuery" class="search-input" placeholder="Search">
                  <div class="search-icon"></div>
                </div>
                <!-- <div class="arrow" (click)="toggleSaveSelectionList('Shared With Me')">
                            <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isSharedWithMeListVisible}">
                            </div>
                          </div> -->
              </div>

            </div>
            <div class="list-container-options" *ngIf="isSharedWithMeListVisible">
              <div class="custom-table-container">

                <!-- <table class="custom-table" *ngIf="displayTable"> -->
                <table class="custom-table">
                  <thead *ngIf="loadSharedWithMeSavedScenarioData.length>0">
                    <tr>
                      <!--<th *ngFor="let col of columnConfig.slice(0, -1)" [style.width]="col.sharedWithMe_width">
                                  {{ col.name }}
                                </th>-->

                      <ng-container *ngFor="let col of columnConfig.slice(0, -1)">
                        <ng-container *ngIf="isChangeOfEntryPointConfigured">
                          <th [style.width]="col.sharedWithMe_width">
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                          <th [style.width]="col.sharedWithMe_width_change">
                            {{ col.name }}
                          </th>
                        </ng-container>
                      </ng-container>
                      <th style="width: 30%;">
                        Email
                      </th>




                    </tr>
                  </thead>
                  <tbody class="custom-load-table-body">
                    <tr [ngClass]="{'scenarioSelected': row.shared_details[0].is_Shared_default}"
                      *ngFor="let row of loadSharedWithMeSavedScenarioData | search: sharedWithMeSelectionQuery : ['selection_name','user_name']">
                      <td [style.width]="isChangeOfEntryPointConfigured? '40%' : '55%'"
                        [attr.title]="row.selection_name"
                        [ngClass]="{'ellipsis-cell-shared': isChangeOfEntryPointConfigured,'ellipsis-cell-shared-noentry': !isChangeOfEntryPointConfigured }">
                        <div class="scenarioName">
                          <!-- <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')"> -->
                          {{ row.selection_name }}
                        </div>
                      </td>
                      <ng-container *ngIf="isChangeOfEntryPointConfigured">
                        <td [style.width]="'13%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')">
                        </td>
                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>

                      </ng-container>

                      <ng-container *ngIf="!isChangeOfEntryPointConfigured">
                        <td [style.width]="'13%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')">
                        </td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                        <td [style.width]="'5%'" class="imageContainer CP  "
                          [ngClass]="row.shared_details[0].is_Shared_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>



                      </ng-container>
                      <td style="width: 30%;" title="{{row.user_name}}">
                        <div class="scenarioName">{{ row.user_name }}</div>
                      </td>

                    </tr>
                    <tr class="no-data" *ngIf="loadSharedWithMeSavedScenarioData.length==0">
                      No saved selections have been shared with you.
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="loadSelectionNoteDiv"><span >Note: </span>Clicking on Radio Button will
            make the selection your Default Selection. Only one selection from either
            User Defined or Shared with Me can be set as Default Selection.</div>
        </div>
        <!-- *ngIf="isFeaturesSelected" -->
        <div class="features-component"  [style]="!(isFeaturesSelected)?'width:0%;opacity:0;visibility:hidden;height:0%;padding:0rem':'width:100%;opacity:1'">
          <div class="features-sections">
            <div class="section-names" [ngClass]="{'section-names-selected':isCustomReport}"
              (click)="onFeaturesSectionClick('customReport')">Custom Reports</div>
            <div class="section-names" [ngClass]="{'section-names-selected':isCustomVariable}"
              (click)="onFeaturesSectionClick('customVariable')">Custom Variable</div>
          </div>
          <app-custom-reports-aesthetics *ngIf="isCustomReport" [study_name]="selected_study"
          (closePopup)="closeCustomReportPop()" [client_name]="selected_client"
          [showBrandAnalysis]="is_brandAnalysis"></app-custom-reports-aesthetics>
          <div class="feature-section-component" *ngIf="isCustomVariable && !isCreateCustomGroup">
            <app-shared-popup *ngIf="isCustomGroupClick && isCustomVariable"
              [isSnapshotCustomGroupClick]="isCustomGroupClick && isCustomVariable"
              [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
              [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [showLoaderPopUp]="false"
              [isCustomGroups]="true" [isShareMetric]="true" (isCustomGroupVisible)="handleCustomGroupPopUp($event)"
              (bindCustomGroupFlags)="bindCustomGroupFlags($event)"></app-shared-popup>
          </div>
          <div class="feature-section-component" *ngIf="isCustomVariable && isCreateCustomGroup">
            <app-custom-variables *ngIf="isCreateCustomGroup && (bindCustomGroupFlagsData != null)"
              [selected_study]="selected_study" [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
              [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [selected_client]="selected_client"
              [dataArray]="dataArray" (closeCustomVariableScreen)="closeCustomVariableScreen($event)"
              [bindCustomGroupFlagsData]="bindCustomGroupFlagsData"
              (customvariable)="customvariable($event)"></app-custom-variables>
          </div>

        </div>
      </div>
    </div>
    
    <div class="output-view" id="output-div" >
        <div class="selection-top-panel">
            <div class="filter-area" (click)="toggleLeftPanel()" >
                <div class="filter-image"></div>
                <div class="filter-text">Filter</div>
            </div>
            <div [class.hidden]="!isSubmitClicked" class="infoRibbon summaryPanel" #summaryText DocumentClick (DocumentClicked)="closeSelectionSummary();">
                <!--selection summary Panel-->

                <div class="InfoRibbonText">
                    <div class="InforRibbonTextValues" #inforRibbon></div>
                </div>
                
                <div class="InfoCollapse" (click)="OnSelectionBtnClick()">
                    <div class="arrowToggle info-collapse-icon"></div>
                </div>
                <!-- <div class="InfoCollapse" (click)="selectionSummaryBlock()">
                    <div class="arrowToggle info-collapse-icon"></div>
                </div> -->

                <div class="save-selection-area" (click)="saveSelection()">
                    <div class="save-selection-image"></div>
                    <span class="save-selection-text">Save Selections</span>
                </div>

                <!-- <div class="downloadExport" (click)="toggleContainer()" >
                    <div class="download"></div>
                </div> -->
            </div>
        </div>
        


          <div class="extraSelections" *ngIf="isSubmitClicked">
            <ng-container *ngIf="isSubmitClicked">
                <div class="sigIndexArea">
                  <div class="sigArea">
                      <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                          [ngClass]="{'initialSelected': isSigSelected}"
                          (click)="onSigType($event);select('sig',$event)">
                          <p style="width:100%;text-align: center; font-size: 0.75rem;" class="btn-text">Sig</p>
                          <img *ngIf="significanceTypes.length > 1"
                              src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon-sig">
                      </div>
                      <div *ngIf="sigTypeDropdown && significanceTypes.length > 1" class="a" DocumentClick
                          (DocumentClicked)="closeSigDropdown()">
                          <div *ngFor="let type of significanceTypes" class="dropdown-values-sig"
                              (click)="onSigTypeClick(type,$event)">
                              <div style="padding-top:3%"><input type="radio" name="type" [value]="type.value"
                                      [checked]="type.selected" class="inputValues">
                              </div>
                              <div class="itemData" title="{{type.name}}">{{type.name}}</div>
                          </div>

                      </div>

                  </div>
                  <div class="indexArea">
                      <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                          [ngClass]="{'initialSelected': isIndexSelected}"
                          (click)="select('index',$event)">
                      <p style="width:100%;text-align: center;font-size: 0.75rem;" class="btn-text">Index</p>
                      </div>
                  </div>
              </div>
              <div class="dropdown-container">

                  <div class="significanceDropdown" DocumentClick (DocumentClicked)="closeSignificance()"
                      *ngIf="sigConBaseToggle">
                      <div>Significance</div>
                      <div class="significance-dropdown-outer-body">


                          <div class="dd" (click)="onSignificanceDropdown()">
                              <p class="dropdown-btn-text">{{displaySignificance}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}"></div>
                          </div>
                          <!-- *ngIf="significanceDropdownToggle" -->
                          <div [ngClass]="significanceDropdownToggle ? 'show-dropdown'  : 'hide-dropdown'" class="b">
                              <div *ngFor="let item of significanceVal" class="dropdown-values"
                                  (click)="significanceSelected1(item,$event)">

                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': selectedSignificance === item}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                      <div class="reference-icon-style"
                                          *ngIf="item.key=='Reference'">
                                          <!-- src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" -->
                                          <div [ngClass]=" !displayBrand ? 'Down-Arrow-reference' : 'Up-Arrow-reference'"></div>
                                      </div>

                                  </div>
                                  <!-- *ngIf="item.key=='Reference' && displayBrand" -->
                                  <div [ngClass]="item.key=='Reference' && displayBrand ?'show-dropdown'  : 'hide-dropdown'" class="mainBrandDiv">
                                      <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                          <input type="text" [(ngModel)]="searchQuery" class="searchInput"
                                              placeholder="Search" />
                                          <div class="search-icon"></div>
                                      </div>
                                      <div style="width:100%;height:9rem;overflow: auto;">
                                          <div *ngFor="let brand of allSigBrands| search : searchQuery : ['MetricOption'];let i = index"
                                              class="brandsDiv" (click)="brandSig(brand,$event)"
                                              [ngClass]="{'selected-item': selectedReference === brand}">
                                              <div style="padding-top:3%"><input style="width: 96%;" type="radio" name="section"
                                                      [value]="brand.key" [checked]="brand.isSelected"
                                                      class="inputValues">
                                              </div>
                                              <div class="brandPara" style="padding-left:4%"
                                                  title="{{brand.MetricOption}}">
                                                  {{brand.MetricOption}}</div>
                                          </div>
                                      </div>

                                  </div>

                              </div>
                          </div>

                      </div>
                      
                  </div>
                  <div class="confidenceLeveldropdown DNN" (click)="onCLclick()" *ngIf="sigConBaseToggle">
                      <div>Confidence Level </div>
                      <div class="confidence-level-outer-body">


                          <div class="dd" (click)="onConfidenceLevelDropdown()">
                              <p class="dropdown-btn-text">{{displayConfidenceLevel}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <!-- *ngIf="ConfidenceLevelDropDownToggle" -->
                          <div [ngClass]="ConfidenceLevelDropDownToggle ? 'show-dropdown'  : 'hide-dropdown'" class="Confidence-level-dropdown">
                              <div *ngFor="let item of confidenceLevel" class="dropdown-values"
                                  (click)="confidenceLevelSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': displayConfidenceLevel === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                  </div>
                  <div class="referenceDropdownCSS" *ngIf="!sigConBaseToggle">
                      <div>Reference</div>
                      <div class="reference-dropdown-outer-body">
              
              
                          <div class="dd" (click)="onReferenceDropdown()" DocumentClick
                              (DocumentClicked)="closeReferenceDropdown()">
                              <p class="brandDisplayDiv">{{displayReference}}</p>
                              <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                          </div>
                          <!-- *ngIf="referenceDropdownToggle" -->
                          <div [ngClass]="referenceDropdownToggle ? 'show-dropdown'  : 'hide-dropdown'" class="ref">
                              <div class="search-row-block" (click)="searchBoxClick($event)">
                                  <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                                  <div class="search-icon"></div>
                              </div>
                              <div class="reference-dropdown-block">
                                  <div *ngFor="let item of allbrands| search : searchQuery : ['MetricOption'];let i = index"
                                      class="ref-dropdown-values" (click)="referenceSelected(item)"
                                      [ngClass]="{'selected-item': selectedReference === item}">
                                      <div style="padding-top:3%;width:13%"><input type="radio" name="section"
                                              [value]="item.MetricOption" [checked]="item.isSelected" class="inputValues">
                                      </div>
                                      <div class="brandPara" title="{{item.MetricOption}}">{{item.MetricOption}}</div>

                                  </div>
                              </div>
                          </div>

                      </div>
                  </div>

                  <div class="baseDropdown" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData">
                      <div>Base</div>
                      <div class="base-dropdown-outer-body">


                          <div class="dd" (click)="onBaseDropdown()" DocumentClick
                              (DocumentClicked)="closeBaseDropdown()">
                              <p class="dropdown-btn-text">{{baseselected}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <!-- *ngIf="BaseDropDownToggle && isAnswerBase" -->
                          <div [ngClass]="BaseDropDownToggle && isAnswerBase ? 'show-dropdown':'hide-dropdown'" class="Base-dropdown"
                              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                              <div *ngFor="let item of base" class="dropdown-values" (click)="baseSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': baseselected === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <!-- *ngIf="BaseDropDownToggle && !isAnswerBase" -->
                          <div [ngClass]="BaseDropDownToggle && !isAnswerBase ? 'show-dropdown':'hide-dropdown'" class="Base-dropdown"
                              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                              <div *ngFor="let item of base2" class="dropdown-values" (click)="base2Selected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': baseselected === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                  </div>

                  <div class="weightdropdownContainer" *ngIf="weight.length>1">
                      <div>Weight </div>
                      <div class="weighted-dropdown-outer-body">

                          <div class="dd" (click)="onWeightDropdown()" DocumentClick
                              (DocumentClicked)="closeWeightDropdown()">
                              <p class="dropdown-btn-text">{{weightSelectedValue}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <!-- *ngIf="weightDropDownToggle" -->
                          <div class="weight-dropdown" [ngClass]=" weightDropDownToggle ? 'show-dropdown' : 'hide-dropdown' " 
                              [ngClass]="{'Index-weight-dropdown': isIndexSelected}">
                              <div *ngFor="let item of weight" class="dropdown-values" (click)="weightSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': weightSelectedValue === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                  </div>
              </div>
              <div class="insightcontainer">
                  <div class="insight-download-area">
                      <div class="download-icon-background" [ngClass]="showContainer && showExportContainer ? 'bg-download-active' :'bg-download-inactive'" (click)="toggleContainer()">
                          <div class="download-icon" [ngClass]="showContainer && showExportContainer ?'bg-download-active-image':'bg-download-inactive-image'"></div>
                      </div>
                      <div class="insight-btn" *ngIf="false">
                          <div class="insight-image">
                          </div>
                          <div class="insight-text">
                              Insights
                          </div>
                      </div>
                  </div>
                  <!-- <div class="polygon showPanel" *ngIf="showContainer && showExportContainer">
                      <div class="polygon-icon poly-icon"></div>
                  </div> -->
                  <div class="setting-container showPanel" *ngIf="showContainer && showExportContainer">
                      <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT && hasTrendline" (click)="OnExportClicked('ppt',true)">
                          <div class="setting-block-icon ppt-icon-trend"></div>
                          <div class="setting-block-name">PPT Trended (Editable)</div>
                      </div>
                      <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT" (click)="OnExportClicked('ppt',false)">
                        <div class="setting-block-icon ppt-icon"></div>
                        <div class="setting-block-name">PPT (Editable)</div>
                      </div>
                      <div class="setting-blocks screengrabPPTSettings"  *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                          <div class="setting-block-icon ppt-icon"></div>
                          <div class="setting-block-name">PPT (Static)</div>
                      </div>
                      <!-- excelexportClicked() -->
                      <div class="setting-blocks excelexportSettings"  (click)="OnExportClicked('excel',false)">
                        <div class="setting-block-icon excel-icon"></div>
                        <div class="setting-block-name">Excel</div>
                      </div>
                      <div class="setting-blocks excelexportSettings" *ngIf="hasTrendline"  (click)="OnExportClicked('excel', true)">
                          <div class="setting-block-icon excel-icon-trend"></div>
                          <div class="setting-block-name">Excel (Trendline)</div>
                      </div>
                  </div>
                  

              </div>
            </ng-container>
              
              <!-- //------------------------------------Index----------------------------------- -->

          </div>
        
        <ng-container *ngIf="isSubmitClicked" >
        <!-- ------------------------------------------------- -->
          <div class="subSectionDiv">
              <!-- <div *ngFor="let item of subSectionNames" class="allSubSectionDiv" (click)="OnSubSectionClick(item)">
                  <div class="subSection" [ngClass]="{'initialSelected': item.isSelected}">{{item.name}}</div>
              </div> -->
          </div>
        <!-- ------------------------------------------------------- -->
        <div style="display: flex; flex-direction: column; min-height: calc(100vh - 100px);">
        <!-- ------------------------Charts area------------------------------- -->
          <div class="outputWidgetArea" *ngIf="showOutputView" style="flex: 1; overflow-y: auto;" id="widget-display-div">
              <app-custom-widget-output (pageCounterChanged)="onPageCounterChange($event)" style="width:100%;flex: 1;"
                  [outputData]="output_details" [sigIndex]="sigIndex"></app-custom-widget-output>             
          </div>
        <!-- ---------------------------------------- -->

          <div style="display: flex; justify-content: center; align-items: center; height: 100%;"
              *ngIf="!showOutputView && !showDefaultPanel"> No Data Available</div>
        <!-- -----------------------Footer Area------------------------------------- -->

          <div class="outputFooterArea">
              <div class="sampleBtn " (click)="showSampleSizePopup()" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData">
                  <div class="samplesize-btn-text">Sample Size</div>
              </div>
              <div class="footer-text">
                <div class="footer-text-container">
                  <div class="staticLsIsText">
                    <div class="ls-is-text">* - Indicates Low Base ({{LowBase}})</div>
                    <div class="ls-is-text"><span style="font-weight: bold;">I/S</span> - Indicates Insufficient Base
                        ({{insufficientBase}})</div>
                    <div class="ls-is-text"><span style="font-weight: bold;">NA</span> - Indicates Base = 0</div>
                    <!-- <div class="significance-positive">• Significantly Higher</div>
                    <div class="significance-negative">• Significantly Lower</div> -->
                  </div>
                  <div *ngIf="isIndexSelected" class="indexText" title="{{indexText}}">
                      Note: The indexed value greater than <span style="color:green">{{higherIndexValue}} are denoted
                          by
                          green</span> and in <span style="color:red">Red for values less than
                          {{lowerIndexValue}}</span>
                  </div>
                  <div *ngIf="isSigSelected && displaySignificance != 'None'" class="sigFooterText">
                      <span style="color:green;">• Significantly Higher</span>
                      <span style="color:red;">• Significantly Lower</span>
                  </div>
                </div>
                <div class="pagination-container" *ngIf="showOutputView && this.pageData.length > 1">
                    <div class="page-icon">
                      <div class="vector-1"></div>
                      <div class="vector-2"></div>
                    </div>
                    <div class="page-icon-hover">
                      <div class="page-left" (click)="OnPageClick('left')" [ngClass]="{'disabled': disableLeftClick || pageCounter == 1, 'bg-color-active' : leftClicked, 'bg-color-inactive' : !leftClicked}">
                        <div class="vector-1-hover"></div>
                        <div class="left-text">Prev</div>
                      </div>
                      <div class="page-number-text">
                        {{this.pageCounter}}/{{this.pageData.length}}
                      </div>
                      <div class="page-right" (click)="OnPageClick('right')" [ngClass]="{'disabled':disableRightClick || pageCounter == pageData.length, 'bg-color-active' : rightClicked, 'bg-color-inactive' : !rightClicked}">
                        <div class="right-text" >Next</div>
                        <div class="vector-2-hover"></div>
                      </div>
                      <!-- <div class="vector-2"></div> -->
                    </div>
                </div>
                
                <div class="i-icon-text">
                  <div *ngIf="stacticText">
                    <div class="i-icon-hover">
                      <div class="i-icon-hover-image"></div>
                      <div class="i-icon-hover-text">{{stacticText}}</div>
                      <div class="rectangle"></div>
                    </div>
                    <div class="icon-image"></div>
                  </div>
                  
                  <div class="source-bgs-text"><span class="first-text">Source : </span><span class="second-text">{{ mainStudy }}</span></div>
                  
                </div>
              </div>
              <!-- <div [title]="stacticText" class="staticText"> {{stacticText}}</div> -->
              <!-- <div class="saveSelection-btn config-footer-btn config-ftr" (click)="saveSelection()"
                  [style]="showSaveSelectionButton?('display:flex;'+(_configService.isSemiAggregatedData || _configService.isAggregatedData?'right:2.5% !important':'')):'display:none;'">
                  <div class="btn-icon save-icon"></div>
                  <div class="btn-text">Save Selection</div>
              </div> -->
              <!-- <div class="sampleBtn " (click)="showSampleSizePopup()" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData">Sample Size</div> -->
          </div>

        </div>
          
        </ng-container>
        <!-- <div class="polygon showPanel" *ngIf="showContainer && showExportContainer" >
            <div class="polygon-icon poly-icon"></div>
        </div>
        <div class="setting-container showPanel" *ngIf="showContainer && showExportContainer" >
            <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT" (click)="editablePPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Editable)</div>
            </div>
            <div class="setting-blocks screengrabPPTSettings"  *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Static)</div>
            </div>
            <div class="setting-blocks excelexportSettings"  (click)="excelexportClicked()">
                <div class="setting-block-icon excel-icon"></div>
                <div class="setting-block-name">Excel</div>
            </div>
        </div> -->



        <!-- ----------------------------------------------------------------- -->

       

        <!-- ------------------------------------------------------------ -->
    </div>  
    <div *ngIf="showSelectionSummary" class="slide-in-wrapper">
      <app-selection-summary-view
        [ngClass]="isSaveSelectionClick ? 'slide-in' : 'slide-out'"
        (SaveSelectionClick)="SaveSelection($event)"
        [isSaveSelectionClick]="isSaveSelectionClick"
        (isSavePopUpVisible)="handleSavePopUP($event)"
        [Header]="summaryViewHeader"
        [isSelectionSummaryClick]="isSelectionSummaryClick"
      ></app-selection-summary-view>
    </div>
    <!-- <div class="no-data-screen DN"> Snapshot is not configured. Please contact Admin.</div> -->
    
  </div>
</ng-container>

<section style="font-size: 0.7rem;">
  <!-- <app-shared-popup *ngIf="isCustomGroupClick" [isCustomGroupClick]="isCustomGroupClick"
    [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
    [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [showLoaderPopUp]="false"
    [isCustomGroups]="true" [isShareMetric]="true" (isCustomGroupVisible)="handleCustomGroupPopUp($event)"
    (bindCustomGroupFlags)="bindCustomGroupFlags($event)"></app-shared-popup> -->
  <app-custom-reports *ngIf="isCustomReportSnapshotClick" [study_name]="selected_study"
    (closePopup)="closeCustomReportPop()" [client_name]="selected_client"
    [showBrandAnalysis]="is_brandAnalysis"></app-custom-reports>
</section>
<!-- this.outputData -->
<app-shared-popup-snapshot *ngIf="showSampleSizePop" [showSampleSizePopup]="showsamplesizepopup"
  [showInputPopUp]="false" [showErrorPopUp]="false" [popUpParameter]="'SampleSize'"
  [OutputdataObject]="OutputdataObject" [snapshotdata]="this.sampleSizeOutputData" [isTranspose]="false"
  [isTotalBase]="true" [isAnswerBase]="false" [isSampleSize]="isSampleSize"
  [TrendToggleContainer]="TrendToggleContainer" [TrendToggleOn]="TrendToggleOn"
  (closeSamplesizePopUp)="onCloseIconClick($event)" [SnapShotType]="this._configService.selectedSnapshotType"
  [weightSelectedValue]="weightSelectedValue"></app-shared-popup-snapshot>


<app-shared-popup-snapshot *ngIf="isLoadSelection && !isDefaultLoad"
  [loadUserDefinedSavedScenarioData]="loadUserDefinedSavedScenarioData"
  [loadSharedWithMeSavedScenarioData]="loadSharedWithMeSavedScenarioData" [popUpParameter]="errorheaderTitle"
  [errorheaderTitle]="popUpTitle" [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
  [isChangeOfEntryPointConfigured]="true" (isLoadClickOutput)="onCloseIconClick($event)" [showErrorPopUp]="false"
  [showLoadSelection]="isLoadSelection" (ShareSelectionClick)="ShareSelection($event)"
  (currentSavedScenarioData)="bindcurrentSavedScenarioData($event)" (deleteMessage)="bindDeleteMessage($event)"
  (isShowDialog)="updateShowDialog($event)"
  (bindSelectedScenario)="bindSelectedScenario($event)"></app-shared-popup-snapshot>

<app-confirmation-dialog id="deleteConfirmation" *ngIf="isShowDialog" [messageText]="deleteMessage"
  (confirmed)="onConfirmation($event)"></app-confirmation-dialog>

<app-shared-popup-snapshot *ngIf="isShareSelectionClick" [shareSelectionUserList]="shareSelectionUserList"
  [showLoaderPopUp]="showLoaderPopUp" [selectedEmailsToShare]="selectedEmailsToShare"
  [selectedLoadSelectionObj]="selectedLoadSelectionObj" [isShareSelectionClick]="isShareSelectionClick"
  (isShareSelectionVisible)="handleShareSelectionPopUp($event)"
  (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot>


<!-- <app-shared-popup-snapshot *ngIf="isSaveSelectionClick" [showInputPopUp]="false" [showErrorPopUp]="false"
  [isSaveSelectionClick]="isSaveSelectionClick" [showLoaderPopUp]="showSaveSelectionPopup"
  [popUpParameter]="errorheaderTitle" (isSavePopUpVisible)="handleSavePopUP($event)"
  (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot> -->

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
  [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
  (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="showErrorPopUp"></app-shared-popup-snapshot>

  <app-report-issue-popup *ngIf="isReportIssue" (closePopup)="isReportIssue = false"></app-report-issue-popup>

  <app-export-downloads-popup (closePopup)="showExportsDownloadsPopup = false" [showExportsDownloads]="showExportsDownloadsPopup"
  *ngIf="showExportsDownloadsPopup" [ReportInput]="exportReportInput"></app-export-downloads-popup>
